import { render } from "./App.vue?vue&type=template&id=bea819ee"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/home/orvux/Devel/JACons/Clientes/Rhinos/rhinos-tickets-center/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__